module.exports = __webpack_public_path__ + "img/zm_chengg@3x.0d9b6cc0.png";